import './App.css';

import MainPage from './main page/MainPage';

function App() {
  return (
    <div  className="App">
     <MainPage/>
    </div>
  );
}

export default App

//https://bootstrapmade.com/demo/DevFolio/